//import the embeddable class
var TrackedPostmailEmbeddable = require("../../embeddables/TrackedPostmailEmbeddable") ;

var trackedPostmailController = new TrackedPostmailEmbeddable();

module.exports = trackedPostmailController ;